import { StandardEvents } from '@shopify/events';

/**
 * Wisteria: actualiza los montos del calculador de cuotas al cambiar de variante.
 *
 * Mismo patron que assets/product-price.js de Horizon: el evento productSelect
 * trae el HTML de la seccion ya renderizado para la variante nueva, asi que se
 * copian los montos que calculo Liquid en vez de formatear dinero en JS.
 * Solo se reemplaza la frase con los montos.
 */
class WisteriaCuotas extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const selector = `wisteria-cuotas[data-block-id="${this.dataset.blockId}"]`;
        const updated = html.querySelector(selector);

        // Bajo el precio minimo el bloque no se renderiza: ocultarlo sin quitarlo,
        // para que vuelva a aparecer si el cliente elige otra variante
        this.hidden = !updated;
        if (!updated) return;

        const text = this.querySelector('[data-cuotas-text]');
        const newText = updated.querySelector('[data-cuotas-text]');
        if (text && newText) text.replaceWith(newText);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[wisteria-cuotas] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('wisteria-cuotas')) {
  customElements.define('wisteria-cuotas', WisteriaCuotas);
}
